// src/hooks/useSegments.js
import { useMutation, useQuery } from "@apollo/client";
import { deleteSegment } from "../graphql/mutations/createSegment";
import { listSegments } from "../graphql/queries/listSegments";

export function useSegments(filter) {
  const { loading, error, data, refetch } = useQuery(listSegments, {
    variables: { filter },
  });

  const [deleteSegmentCall, { loading: deleteLoading }] = useMutation(deleteSegment);

  return {
    loading,
    error,
    segments: data ? data.listSegments : [],
    refetch,
    deleteSegmentCall,
    deleteLoading,
  };
}
